import { get, omit, noop } from 'lodash-es'
import { formPost } from '@/utils/form-emulator'
import { WOS, WR } from '@/utils/goto-url'

const adyenHandler = (url, options) => {
  formPost(url, options)
}
export const thirdPartyHandler = (ctx, cb = noop) => {
  ctx.$emit('goTo', { component: 'Result', type: 'unknown', thirdParty: true })
  setTimeout(() => {
    window.thirdPartyWin = cb()
  }, 1000)
}
export function paymentChannelHandler ({ res, ctx }) {
  const { pay_channel_id: payChannelID } = res
  const paytmActionUrl = get(res, 'payInfo.WAP_GATEWAY_URL', '')
  const adyenActionUrl = get(res, 'payInfo.post_url', '')
  const toCtoPActionUrl = get(res, 'payInfo.instContext.post_url', '')
  const globalAlipayUrl = get(res, 'payInfo.channelRedirectUrl', '')
  const paymeUrl = get(res, 'payInfo.channelRedirectUrl', '')
  const channelRedirectUrl = get(res, 'payInfo.channelRedirectUrl', '')
  const loading = (duration = 5000) => {
    ctx.$Spin.show()
    setTimeout(() => {
      ctx.$Spin.hide()
    }, duration)
  }

  switch (payChannelID) {
    case 901:
      return this.$emit('goTo', { component: 'Adyen', payChannelID: payChannelID })
      // adyen
    case 902:
    case 903:
      loading()
      adyenHandler(adyenActionUrl, omit(get(res, 'payInfo', {}), ['post_url']))
      break
      // paytm
    case 1002:
      thirdPartyHandler(ctx, () => formPost(paytmActionUrl, omit(get(res, 'payInfo', {}), ['WAP_GATEWAY_URL'])))
      break
    case 1100:
      thirdPartyHandler(ctx, () => formPost(toCtoPActionUrl, omit(get(res, 'payInfo.instContext', {}), ['post_url'])))
      break
    case 1200 :
    case 1201 :
    case 1202 :
    case 1302 :
    case 1900:
      thirdPartyHandler(ctx, () => WOS(globalAlipayUrl))
      break
    case 1500:
      return ctx.$emit('goTo', { component: 'Tappay', payChannelID: payChannelID })
    case 1801:
      ctx.$emit('goTo', { component: 'Payme', payChannelID: payChannelID, payUrl: paymeUrl })
      break
    case 216:
      ctx.$emit('goTo', { component: 'Wechat', payChannelID: payChannelID, payUrl: paymeUrl })
      break
    case 2100:
      loading()
      WR(channelRedirectUrl)
      break
    case 2001:
    case 2102:
    case 2109:
    case 2104:
      thirdPartyHandler(ctx, () => WOS(channelRedirectUrl))
      break
    default:
      ctx.$Message.warning(ctx.$t('errors.unknownPaymentMethod'))
      break
  }
}
